import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface State {
  hasError: boolean;
  message: string;
}

export class WorkflowErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error: unknown): State {
    const message = error instanceof Error ? error.message : String(error);
    return { hasError: true, message };
  }

  handleReset = () => this.setState({ hasError: false, message: '' });

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
            Workflow tab failed to load
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontFamily: 'monospace', fontSize: '0.75rem' }}>
            {this.state.message}
          </Typography>
          <Button size="small" variant="outlined" onClick={this.handleReset}>
            Retry
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
